/**
 * REQ-0028 详情页修改船「有效变更」谓词（零依赖，可单测）。
 *
 * 从 JobUtils.vesselOrVoyageChange 原三臂 if 谓词逐臂抽取（语义零变化），
 * 供 util 内船期字段清理触发与基本页签 ATD 清空共用（决议②④：船名航次
 * 页签 tabVesselEqPM 与 HBL 页签 tabHBLPM 的改船名/航次——含清空——均清 ATD）。
 * 本模块刻意保持零 import（不引 store/router 链），供 Jest 直接加载（PLAN §0 可测性边界）。
 */

/**
 * 船名/航次「有效变更」判定。三臂与原内联谓词一一对应：
 *   1) job[field] && newVal && job[field] !== newVal           常规改值
 *   2) oldVessel && !job[field] && newVal && oldVessel !== newVal  现值为空、与上次手输不同
 *      （oldVessel 代表客户每次修改的值，见 JobUtils 调用方 view.oldVessel）
 *   3) !newVal                                                    清空
 *
 * @param job   业务对象（field 取 job[field] 现值）
 * @param field 'vessel' | 'voyageFlight'
 * @param newVal 本次输入值（空值视为清空，臂 3）
 * @param oldVessel 上次手输值（默认 ''，即 tabHBLPM 不传形态）
 * @returns {boolean}
 */
export function isVesselOrVoyageChanged(job, field, newVal, oldVessel = '') {
  if (!newVal) {
    return true
  }
  if (job[field] && job[field] !== newVal) {
    return true
  }
  if (oldVessel && !job[field] && oldVessel !== newVal) {
    return true
  }
  return false
}
